const isSupplementaryCoverLocked = () => false;

export default isSupplementaryCoverLocked;
